import { application } from './application'
import PaletteController from './palette_controller'
import NavGroupsController from './nav_groups_controller'
import CountUpController from './count_up_controller'
import AutoSubmitController from './auto_submit_controller'
import QueueShareController from './queue_share_controller'
import PasskeyController from './passkey_controller'

application.register('palette', PaletteController)
application.register('nav-groups', NavGroupsController)
application.register('count-up', CountUpController)
application.register('auto-submit', AutoSubmitController)
application.register('queue-share', QueueShareController)
application.register('passkey', PasskeyController)
